import { SwApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import { getAllProjects } from "../api/projects";

export const projectsStore = SwApiStore({
  get: () => getAllProjects({ all: false }),
  init: () => [],
});
